import { IsDefined, IsNotEmpty, IsString, Length } from 'class-validator';

export class AiAssistantUserMessageDto {
  @IsDefined()
  @IsString()
  @IsNotEmpty()
  @Length(1, 1000)
  text: string;
}